import type { GlobalAppsPageContext } from './types';

/**
 * Returns true if the pilotFlag exists in pageContext, false otherwise
 * @param {Object} pageContext The server's page context object
 * @param {String} pilotFlag Indicate the pilot's string name
 * @returns {Boolean} true if the pilotFlag exists in pageContext, false otherwise
 */
export const isPilotEnabled = (pageContext?: GlobalAppsPageContext | null, pilotFlag?: string) => {
  const permissions = pageContext?.Permissions;
  const dynamic = permissions?.dynamic;

  // Preserve spread precedence, including explicit false and undefined overrides, without copying every pilot.
  if (dynamic && Object.prototype.propertyIsEnumerable.call(dynamic, pilotFlag)) {
    return dynamic[pilotFlag] === true;
  }
  if (permissions && Object.prototype.propertyIsEnumerable.call(permissions, pilotFlag)) {
    return permissions[pilotFlag] === true;
  }

  const legacy = pageContext?.FeaturePilotFlag;
  return !!legacy && Object.prototype.propertyIsEnumerable.call(legacy, pilotFlag) && legacy[pilotFlag] === true;
};
